"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6887],{

/***/ 96887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var hooks_useLocation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8022);
/* harmony import */ var providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79139);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91260);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63069);
/* harmony import */ var _IdeaCard_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17630);
/* harmony import */ var _IdeaCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_IdeaCard_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _useIdeaCardContentUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1650);











var IdeaCardContentQuote = function(param) {
    var headingSize = param.headingSize, idea = param.idea, preloadImage = param.preloadImage, size = param.size, isNotInteractable = param.isNotInteractable, shouldTrim = param.shouldTrim, disableTitleHref = param.disableTitleHref;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isLoggedIn = (0,providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isLoggedIn;
    var location = (0,hooks_useLocation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var image = idea.image, content = idea.content, authorName = idea.authorName, imageBlurhash = idea.imageBlurhash;
    var options = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return {
            decodeEntities: true,
            transform: (0,utils_global__WEBPACK_IMPORTED_MODULE_6__/* .makeTransform */ .tP)(colorMode)
        };
    }, [
        colorMode
    ]);
    // We no longer trim idea card content
    var ref = (0,_useIdeaCardContentUtils__WEBPACK_IMPORTED_MODULE_7__/* .useStylePropsForQuote */ .W)(preloadImage, false, size), textSize = ref.titleTextSize, contentTextSize = ref.contentTextSize, imageSize = ref.imageSize;
    var renderedContent = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        // We set the condition to false in place of removing the function as it also does content parsing
        var parsedContent = (0,utils_global__WEBPACK_IMPORTED_MODULE_6__/* .getConditionallyTrimmedContent */ .b8)({
            condition: !isLoggedIn && shouldTrim,
            content: content,
            colorMode: colorMode,
            options: options
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text
        }, contentTextSize), {
            marginBottom: "0.25rem",
            px: {
                base: "1.5rem",
                lg: "2rem"
            },
            mt: {
                base: "1rem",
                lg: "1.5rem"
            },
            children: parsedContent
        }));
    }, [
        content,
        colorMode,
        options
    ]);
    var imageWrapperStyle = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return {
            width: imageSize,
            height: imageSize,
            borderRadius: "10rem",
            position: "relative",
            overflow: "hidden"
        };
    }, [
        imageSize
    ]);
    var renderIdeaImage = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            wrapperStyle: imageWrapperStyle,
            imageUrl: image,
            alt: authorName || content.substring(0, 30) + "...",
            blurhash: imageBlurhash,
            priority: preloadImage,
            imageModal: "rounded",
            isNotInteractable: isNotInteractable,
            imageClassName: (_IdeaCard_module_scss__WEBPACK_IMPORTED_MODULE_10___default().next_image_quote)
        });
    }, [
        image,
        isNotInteractable
    ]);
    var renderAuthorName = function() {
        if (!authorName) return null;
        var renderedAuthorName = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryHeading, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            type: "bold"
        }, textSize), {
            size: headingSize,
            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
            wordBreak: "break-word",
            px: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem,
            children: authorName.toUpperCase()
        }));
        return !isLoggedIn && !disableTitleHref && (shouldTrim || location === "article" || location === "collection") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
            _hover: undefined,
            href: "/idea/".concat(idea.id, "/").concat((0,utils_global__WEBPACK_IMPORTED_MODULE_6__/* .slugify */ .lV)(idea.title, idea.content)),
            children: renderedAuthorName
        }) : renderedAuthorName;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
        textAlign: "center",
        flexDir: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "inherit",
        w: "100%",
        flexGrow: 1,
        pt: {
            base: "1rem",
            lg: "2rem"
        },
        children: [
            image && renderIdeaImage(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                cursor: "unset",
                justifyContent: "center",
                alignItems: "center",
                flexDir: "column",
                children: renderedContent
            }),
            renderAuthorName()
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (IdeaCardContentQuote);


/***/ })

}]);